// extracted by mini-css-extract-plugin
export default {"tab":"styles_tab__lWgq3","selected":"styles_selected__Xp2OK","tab__counter":"styles_tab__counter__sFay3","opened":"styles_opened__McRiJ"};